import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import MultipleProgressBar from '@/components/common/MultipleProgressBar.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'

  import type { CourseProgress } from '@/services/interfaces/Course'
  import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseExamHeader',
  props: {
    loadingExamContent: {
      type: Boolean,
      required: true,
    },
    progressBarOptions: {
      type: Array as PropType<CourseProgress[]>,
      required: true,
    },
    isPartOneDone: {
      type: Boolean,
      required: true,
    },
    noQuestionsAnsweredYet: {
      type: Boolean,
      default: true,
    },
    continueExamRequest: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['continue-exam', 'pause-or-end-exam'],
  setup(__props) {

const props = __props;

  

  

  const { play, pauseBtn } = useIcons()
  const { inCourseExamResultsPage, isCourseExamPaused, totalExamQuestions, reviewingQuestion, isCourseExamTrialEnded } =
    useCourse()
  const { isSmallerMobileDevice } = useBreakpoint()

  // const isFirstQuestion = computed(() => currentExamQuestion.value?.questionNumber === 1)

  const showContinueExam = computed(
    () =>
      isCourseExamPaused.value &&
      !props.isPartOneDone &&
      !inCourseExamResultsPage.value &&
      !reviewingQuestion.value &&
      !isCourseExamTrialEnded.value,
  )

  const showEndExam = computed(
    () =>
      inCourseExamResultsPage.value ||
      (reviewingQuestion.value ? true : props.noQuestionsAnsweredYet) ||
      isCourseExamTrialEnded.value,
  )

return { __sfc: true,props, play, pauseBtn, inCourseExamResultsPage, isCourseExamPaused, totalExamQuestions, reviewingQuestion, isCourseExamTrialEnded, isSmallerMobileDevice, showContinueExam, showEndExam, computed, MultipleProgressBar, SVGRenderer, useCourse, useIcons, useBreakpoint }
}

})